import React, { useMemo } from 'react'
import { useMapType, MapType } from '@/component/map/MapContext'
import Menu, { WMOption } from '@/component/menu/Menu'

interface MapSwitcherProps {
    className?: string
}

const MapSwitcher: React.FC<MapSwitcherProps> = ({ className }) => {
    const { mapType, setMapType } = useMapType()

    const menuItems: WMOption[] = useMemo(() => [
        {
            id: 'google',
            text: 'Google Maps',
            onClick: () => setMapType('google' as MapType),
        },
        {
            id: 'baidu',
            text: 'Baidu 百度地图',
            onClick: () => setMapType('baidu' as MapType),
        },
    ], [setMapType])

    return (
        <Menu
            className={className}
            items={menuItems}
            render={
                <div className="flex gap-[10px]">
                    <div className={`
                        text-[14px] select-none rounded-full
                        min-w-[40px] min-h-[40px] flex items-center justify-center
                        transition-colors
                        ${mapType === 'google'
                            ? 'bg-[#4285F4] text-white'
                            : 'bg-[#3385FF] text-white'
                        }
                    `}>
                        {mapType === 'google' ? (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2C6.13 2 3 5.13 3 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7z" fill="white"/>
                                <circle cx="10" cy="9" r="3" fill="#4285F4"/>
                            </svg>
                        ) : (
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 2C6.13 2 3 5.13 3 9c0 5.25 7 11 7 11s7-5.75 7-11c0-3.87-3.13-7-7-7z" fill="white"/>
                                <circle cx="10" cy="9" r="3" fill="#3385FF"/>
                            </svg>
                        )}
                    </div>
                </div>
            }
        />
    )
}

export default MapSwitcher
